<template>
  <div class="big chufang-detail">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="preId"
      :visitType="visitType"
      :visitName="visitName"
      :activeIndexDia="activeIndexDia"
    ></ReturnVisit>
    <!-- 原始图片查看 -->
    <el-dialog
      title="原始处方"
      :visible.sync="pre_img"
      width="800px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <img :src="detail.pre_img" alt style="width: 100%" />
      </div>
    </el-dialog>
    <!-- 禁忌及签名 -->
    <el-dialog
      title="禁忌及签名"
      :visible.sync="sign_img"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px; text-align: left">
        <div style="font-weight: 700; margin-bottom: 6px">处方禁忌情况</div>
        <div v-html="detail.drug_sign_desc"></div>
        <div style="font-weight: 700; margin: 20px 0 5px">医生手写签名</div>
        <img :src="detail.doctor_sign" alt style="width: 150px" />
      </div>
    </el-dialog>

    <div class="page_title flex_between">
      <span>
        <span>处方详情</span>
        <el-button
          type="primary"
          style="margin-left:20px"
          @click="toReturn"
          :disabled="
            module_id_array[0] ? !module_id_array.includes('1315') : false
          "
          >回访
          <span v-if="detail.visit_count">({{ detail.visit_count }})</span>
        </el-button>
      </span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>

    <div style="padding: 20px">
      <div class="container">
        <div class="inbobox">
          <div class="flex">
            <div class="inboitem">
              <div>
                <span class="infotitle">用户昵称：</span>
                <span>{{ detail.nick_name }}</span>
              </div>
              <div style="margin: 12px 0">
                <span class="infotitle">性别：</span>
                <span v-if="detail.user_sex == 1">男</span>
                <span v-if="detail.user_sex == 2">女</span>
                <span v-if="detail.user_sex == 0">未知</span>
              </div>
              <div>
                <span class="infotitle">手机号：</span>
                <span>{{ detail.user_phone }}</span>
              </div>
            </div>
            <div class="inboitem">
              <div style="display: flex">
                <div style="width: 200px;">
                  <span class="infotitle">医生姓名：</span>
                  <span
                    @click="showDocMsg(detail.doctor_id)"
                    style="cursor:pointer"
                    >{{ detail.doctor_name }}</span
                  >
                </div>
                <div style="margin: 0 50px;width: 100px;">
                  <span>性别：</span>
                  <span v-if="detail.doctor_sex == 1">男</span>
                  <span v-if="detail.doctor_sex == 2">女</span>
                </div>
                <div  style="width: 200px;">
                  <span>手机号：</span>
                  <span>{{ detail.doctor_phone }}</span>
                </div>
              </div>
              <div style="display: flex">
                <div style="margin: 12px 50px 12px 0;width: 200px;">
                  <span class="infotitle">职称：</span>
                  <span>{{ detail.title }}</span>
                </div>
                <div style="margin: 12px 0">
                  <span>诊所名称：</span>
                  <span>{{ detail.org_name }}</span>
                </div>
              </div>
              <div>
                <span class="infotitle">科室：</span>
                <span>{{ detail.department_name }}</span>
              </div>
            </div>
          </div>
          <div style="font-size: 15px">
            <span style="font-weight: 700">处方状态：</span>
            <span v-if="detail.is_confirmed == 1" style="margin-right: 10px"
              >已认领</span
            >
            <span v-if="detail.is_confirmed == 2" style="margin-right: 10px"
              >未认领</span
            >
            <el-button
              type="text"
              v-if="
                detail.is_confirmed == 1 &&
                  (detail.is_doctor_sure == 3 || detail.is_doctor_sure == 1) &&
                  detail.pay_status == 0
              "
              style="font-size: 15px"
              @click="cancelBind"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('618') : false
              "
              >解绑</el-button
            >

            <el-popover
              placement="left"
              width="240"
              trigger="click"
              @hide="getDetail"
              v-if="detail.is_confirmed == 2"
            >
              <span>
                <img :src="detail.qrcode" alt style="width: 100%" />
              </span>
              <el-button
                v-if="
                  detail.is_confirmed == 2 &&
                    (detail.is_doctor_sure == 3 || detail.is_doctor_sure == 1)
                "
                slot="reference"
                style="font-size: 15px"
                type="text"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('618') : false
                "
                >绑定</el-button
              >
            </el-popover>
          </div>
        </div>
        <div class="dorder-divider">
          <span>
            <span>开方时间：</span>
            <span>{{ detail.create_time }}</span>
          </span>
          <span style="margin: 0 30px">
            <span>处方状态：</span>
            <span>
              <span v-if="detail.status == 1">待取药</span>
              <span v-if="detail.status == 2">待审方</span>
              <span v-if="detail.status == 3">已通过</span>
              <span v-if="detail.status == 4">已抓药</span>
              <span v-if="detail.status == 5">过期未取药</span>
              <span v-if="detail.status == 6">审方不通过</span>
              <span v-if="detail.status == 7">医生作废</span>
              <span v-if="detail.status == 8">平台退款</span>
            </span>
          </span>
          <span
            style="margin: 0 30px"
            v-if="
              detail.pre_type == 9 || detail.pre_type == 11 || detail.ass_id > 0
            "
          >
            <span>医生确认状态：</span>
            <span>
              <span v-if="detail.is_doctor_sure == 1">无需确认</span>
              <span v-if="detail.is_doctor_sure == 2">待确认</span>
              <span v-if="detail.is_doctor_sure == 3">已确认通过</span>
              <span v-if="detail.is_doctor_sure == 4">已驳回</span>
            </span>
          </span>
          <span>
            <span>处方号：</span>
            <span>{{ detail.pre_id }}</span>
          </span>
          <el-button
            type="text"
            style="margin-left: 50px; font-size: 15px"
            @click="pre_img = true"
            >原始处方 ></el-button
          >
          <el-button
            type="text"
            style="margin-left: 50px; font-size: 15px"
            @click="sign_img = true"
            v-if="detail.doctor_sign"
            >禁忌及签名 ></el-button
          >
        </div>
        <!-- 诊断 -->
        <div class="dorder-divider" style="padding-bottom:10px">
          <div class="title">诊断</div>
          <div>
            <div>
              <span>
                <span>患者：</span>
                <span>{{ detail.user_name }}</span>
                <span style="margin: 0 40px">{{
                  detail.patient_sex == 1 ? "男" : "女"
                }}</span>
                <span>{{ detail.age }}</span>
              </span>
              <span style="margin-left: 30px" v-if="detail.patient_phone">
                <span>手机号：</span>
                <span>{{ detail.patient_phone }}</span>
              </span>
            </div>
            <div style="margin: 14px 0">
              <span>主诉：</span>
              <span>{{ detail.chief_complaint }}</span>
            </div>
            <div>
              <span>诊断：</span>
              <span>{{ detail.diagnosis }}</span>
            </div>
          </div>
        </div>
        <!-- 开方 -->
        <div class="dorder-divider" style="padding-bottom:10px">
          <div class="flex-box">
            <p class="title">开方</p>
            <p class="pre-group">
              {{ detail.pre_group | preGroupText }}
              <span v-if="detail.pre_num != 1"
                >({{ detail.pre_sort }} / {{ detail.pre_num }})</span
              >
            </p>
            <el-button
              type="text"
              v-if="detail.pre_num != 1"
              style="margin-left: auto; font-size: 16px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('615') : false
              "
              @click="viewRelevance"
              >查看关联处方 ></el-button
            >
          </div>
          <div class="flex-box">
            <p>{{ detail.drug_type_name }}</p>
            <p style="margin-left: 20px">{{ detail.hospital_name }}</p>
            <p style="margin-left: auto">
              隐藏剂量：
              <el-radio-group v-model="detail.is_show" @change="changeShow">
                <el-radio :label="0">仅剂量保密</el-radio>
                <el-radio :label="1">不保密</el-radio>
                <el-radio :label="2">药材保密</el-radio>
              </el-radio-group>
            </p>
          </div>
          <div class="title rp">Rp：</div>
          <!-- 中药材(颗粒 饮片 膏方 丸剂) -->
          <div
            class="itembox"
            v-if="
              detail.pre_group == 1 ||
                detail.pre_group == 2 ||
                detail.pre_group == 3 ||
                detail.pre_group == 4
            "
          >
            <div class="item" v-for="(item, index) in item_list" :key="index">
              <span>{{ item.generic_name }}</span>
              <span>
                <span>{{ item.item_use_level }}g</span>
                <span v-if="item.dosage_unit != 2"
                  >({{ item.num }}{{ item.dosage_unit_name }})</span
                >

                <span v-if="item.requirement">({{ item.requirement }})</span>
              </span>
            </div>
          </div>
          <!-- 颗粒饮片的服用方式 -->
          <div
            v-if="
              item_list.length > 0 &&
                (detail.pre_group == 1 || detail.pre_group == 2)
            "
            style="color: #747981"
          >
            <span v-if="detail.drug_machining == 1" style="margin-right: 40px"
              >代煎</span
            >
            <span v-if="detail.use_type == 1" style="margin-right: 20px"
              >内服</span
            >
            <span v-if="detail.use_type == 2" style="margin-right: 20px"
              >外用</span
            >
            共
            <span style="font-weight;600"
              >{{ detail.total_num }} 剂，每{{
                detail.days == 1 ? "" : detail.days
              }}日 1 剂，每日</span
            >分
            <span style="font-weight;600" v-if="detail.use_type == 1"
              >{{ detail.day_num }} 次服用</span
            >
            <span style="font-weight;600" v-if="detail.use_type == 2"
              >{{ detail.day_num }} 次使用</span
            >
            <span v-if="detail.drug_machining == 1"
              >，每次 1 袋，共
              {{ detail.total_num * detail.days * detail.day_num }} 袋</span
            >
          </div>
          <!-- 膏方的服用方式 -->
          <div v-if="detail.pre_group == 3">
            <div>
              <span>膏方辅料</span>
              <span style="margin-left:20px">{{ detail.material_name }}</span>
            </div>
            <div style="margin:5px 0">
              <span>包装方式</span>
              <span style="margin-left:17px">
                <span v-if="detail.packing_method == 1">
                  瓶装
                </span>
                <span v-if="detail.packing_method == 2">
                  袋装
                </span>
                <span>({{ detail.packing_capacity }}ml)</span>
              </span>
            </div>
            <div>
              <span>服用频次</span>
              <span style="margin-left:20px">
                <span>每日{{ detail.day_num }}次，</span>
                <span>
                  <span v-if="detail.packing_method == 1">
                    每次{{ detail.times_capacity }}ml
                  </span>
                  <span v-if="detail.packing_method == 2">
                    每次{{ detail.times_capacity }}袋
                  </span>
                </span>
              </span>
            </div>
            <div style="margin-top:10px">
              注：预计出膏
              {{ Number(detail.min_drug_machining_weight).toFixed(0) }}g -
              {{ Number(detail.drug_machining_weight).toFixed(0) }}g。
            </div>
          </div>
          <!-- 丸剂的服用方式 -->
          <div v-if="detail.pre_group == 4">
            <div>
              <span>服用频次</span>
              <span style="margin-left:20px">
                <span>每日{{ detail.day_num }}次，</span>
                <span>每次{{ detail.times_capacity }}g</span>
              </span>
            </div>
            <div style="margin-top:10px">
              注：预计出丸
              <span>
                {{ Number(detail.min_drug_machining_weight).toFixed(0) }}g -
                {{ Number(detail.drug_machining_weight).toFixed(0) }}g </span
              >。 约服 {{ detail.min_day }} - {{ detail.max_day }} 天
            </div>
          </div>
          <!-- 养生膏方 -->
          <div class="itembox" v-if="detail.pre_group == 0">
            <div v-for="(item, index) in oil_item_list" :key="index">
              <span>{{ item.oil_name }}</span>
              <span>
                <span style="padding: 0 8px"
                  >{{ item.oil_spec }}/{{ item.oil_unit }}</span
                >
                <span style="padding: 0 8px"
                  >{{ item.item_use_level }}{{ item.oil_unit }}</span
                >
              </span>
              <span>{{ item.requirement }} </span>
            </div>
          </div>
          <!-- 成药 -->
          <div class="itembox" v-if="detail.pre_group == -1">
            <div v-for="(item, index) in pm_list" :key="index">
              <span>{{ item.pm_name }}</span>
              <span>
                <span style="padding: 0 8px">{{ item.pm_spec }}</span>
                <span style="color:#9B9B9B;font-size:12px">
                  {{ item.productor }}
                </span>
                <span style="padding: 0 4px">
                  {{ item.item_use_level }}{{ item.pm_unit }}
                </span>
                <span>{{ item.requirement }} </span>
              </span>
            </div>
          </div>
        </div>
        <!-- 医嘱 -->
        <div class="dorder-divider" style="padding-bottom:10px">
          <div class="title">医嘱</div>
          <div>
            <div>
              <span>用法：</span>
              <span>{{ detail.use_method }}</span>
            </div>
            <div style="margin: 14px 0">
              <span>禁忌：</span>
              <span>{{ detail.taboo }}</span>
            </div>
            <div>
              <span>特殊说明：</span>
              <span>{{ detail.doctor_advice }}</span>
            </div>
          </div>
        </div>
        <!-- 费用明细 -->
        <div class="cost-detail">
          <div class="title">费用明细</div>
          <div style="color: #000">
            <div>
              <span class="cost-title">{{ getCostTitle }}：</span>
              <span class="cost-content">{{ detail.drug_price }}</span>
              <span> 元</span>
            </div>
            <div v-if="detail.pre_group == 3" style="margin-top: 14px">
              <span class="cost-title">辅料费：</span>
              <span class="cost-content">{{ detail.excipients_price }}</span>
              <span> 元</span>
            </div>
            <div style="margin-top: 14px" v-if="detail.drug_machining_price">
              <span class="cost-title">加工费：</span>
              <span class="cost-content">{{
                detail.drug_machining_price
              }}</span>
              <span> 元</span>
            </div>
            <div style="margin-top: 14px">
              <span class="cost-title"
                >诊后管理费
                <span v-if="detail.consult_drug_price_in == 1">
                  (与药费合并，不单独显示)：</span
                >
                <span v-else>(在支付明细中单独列出)：</span>
              </span>
              <span class="cost-content">{{ detail.consult_drug_price }}</span>
              <span> 元</span>
            </div>
            <div style="margin: 14px 0">
              <span class="cost-title"
                >诊金
                <span v-if="detail.gold_join == 1">
                  (与药费合并，不单独显示)：</span
                >
                <span v-else>(在支付明细中单独列出)：</span>
              </span>
              <span class="cost-content">{{ detail.consulting_gold }}</span>
              <span> 元</span>
            </div>
            <div>
              <span class="cost-title">总计：</span>
              <span class="cost-content">{{ detail.total_price }}</span>
              <span> 元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关联处方处方详情 -->
    <el-dialog
      title="查看关联处方"
      class="recipe-detail-dialog"
      :visible.sync="recipeDetailDialog"
    >
      <div class="recipe-detail">
        <div v-for="item in relevanceRecipe" :key="item.pre_id">
          <!-- 中药材 -->
          <div
            v-if="
              item.pre_group == 1 ||
                item.pre_group == 2 ||
                item.pre_group == 3 ||
                item.pre_group == 4
            "
            class="item-list"
            style="text-align:left"
          >
            <div class="title-page">
              <p><span class="weight">处方号: </span> {{ item.pre_id }}</p>
              <p class="weight">中药材</p>
              <p>{{ item.drug_type_name }}</p>
              <p>{{ item.hospital_name }}</p>
            </div>
            <div class="itembox">
              <div
                class="item"
                v-for="(item, index) in item.item_list"
                :key="index"
              >
                <span>{{ item.generic_name }}</span>
                <span>
                  <span>{{ item.item_use_level }}g</span>
                  <span v-if="item.dosage_unit != 2"
                    >({{ item.num }}{{ item.dosage_unit_name }})</span
                  >
                  <span v-if="item.requirement">({{ item.requirement }})</span>
                </span>
              </div>
            </div>
            <!-- 用法 -->
            <!-- 颗粒饮片的服用方式 -->
            <div
              v-if="
                item.item_list.length > 0 &&
                  (item.pre_group == 1 || item.pre_group == 2)
              "
              style="color: #747981"
            >
              <span v-if="item.drug_machining == 1" style="margin-right: 40px"
                >代煎</span
              >
              <span v-if="item.use_type == 1" style="margin-right: 20px"
                >内服</span
              >
              <span v-if="item.use_type == 2" style="margin-right: 20px"
                >外用</span
              >
              共
              <span style="font-weight;600"
                >{{ item.total_num }} 剂，每日 1 剂，每剂</span
              >分
              <span style="font-weight;600" v-if="item.use_type == 1"
                >{{ item.day_num }} 次服用</span
              >
              <span style="font-weight;600" v-if="item.use_type == 2"
                >{{ item.day_num }} 次使用</span
              >
              <span v-if="item.drug_machining == 1"
                >，每次 1 袋，共
                {{ item.total_num * item.days * item.day_num }} 袋</span
              >
            </div>
            <!-- 膏方的服用方式 -->
            <div v-if="item.pre_group == 3">
              <div>
                <span>膏方辅料</span>
                <span style="margin-left:20px">{{ item.material_name }}</span>
              </div>
              <div style="margin:5px 0">
                <span>包装方式</span>
                <span style="margin-left:17px">
                  <span v-if="item.packing_method == 1">
                    瓶装
                  </span>
                  <span v-if="item.packing_method == 2">
                    袋装
                  </span>
                  <span>({{ item.packing_capacity }}ml)</span>
                </span>
              </div>
              <div>
                <span>服用频次</span>
                <span style="margin-left:20px">
                  <span>每日{{ item.day_num }}次，</span>
                  <span>
                    <span v-if="item.packing_method == 1">
                      每次{{ item.times_capacity }}ml
                    </span>
                    <span v-if="item.packing_method == 2">
                      每次{{ item.times_capacity }}袋
                    </span>
                  </span>
                </span>
              </div>
            </div>
            <!-- 丸剂的服用方式 -->
            <div v-if="item.pre_group == 4">
              <span>服用频次</span>
              <span style="margin-left:20px">
                <span>每日{{ item.day_num }}次，</span>
                <span>每次{{ item.times_capacity }}g</span>
              </span>
            </div>
            <div class="dorder-divider"></div>
          </div>
          <!-- 成药 -->
          <div v-if="item.pre_group == -1" class="pm-list">
            <div class="title-page">
              <p><span class="weight">处方号: </span> {{ item.pre_id }}</p>
              <p class="weight">成药</p>
              <p>{{ item.hospital_name }}</p>
            </div>
            <div
              v-for="pmItem in item.pm_list"
              :key="pmItem.pm_id"
              class="pm-box"
            >
              <span>{{ pmItem.pm_name }}</span>
              <span>
                <span style="padding: 0 8px">{{ pmItem.pm_spec }}</span>
                <span style="color:#9B9B9B;font-size:12px">
                  {{ pmItem.productor }}
                </span>
                <span style="padding: 0 4px">
                  {{ pmItem.item_use_level }}{{ pmItem.pm_unit }}
                </span>
                <span>{{ pmItem.requirement }} </span>
              </span>
            </div>
            <div class="dorder-divider"></div>
          </div>
          <!-- 养生方 -->
          <div v-if="item.pre_group == 0" class="oil-list">
            <div class="title-page">
              <p><span class="weight">处方号: </span> {{ item.pre_id }}</p>
              <p class="weight">养生膏方</p>
              <p>{{ item.hospital_name }}</p>
            </div>
            <div
              class="oil-box"
              v-for="oilItem in item.oil_item_list"
              :key="oilItem.oil_id"
            >
              <span>
                <span style="padding: 0 8px"
                  >{{ oilItem.oil_spec }}/{{ oilItem.oil_unit }}</span
                >
                <span style="padding: 0 8px"
                  >{{ oilItem.item_use_level }}{{ oilItem.oil_unit }}</span
                >
              </span>
              <span>{{ oilItem.requirement }} </span>
            </div>
            <div class="dorder-divider"></div>
          </div>
        </div>
        <!-- 费用明细 -->
        <div style="color: #000" class="dia-cost-detail">
          <div v-if="relevanceInfo.drug_price">
            <span class="cost-title">中药材：</span>
            <span class="cost-content">{{ relevanceInfo.drug_price }}</span>
            <span> 元</span>
          </div>
          <div v-if="relevanceInfo.pm_price" style="margin-top: 10px">
            <span class="cost-title">成药：</span>
            <span class="cost-content">{{ relevanceInfo.pm_price }}</span>
            <span> 元</span>
          </div>
          <div v-if="relevanceInfo.oil_price" style="margin-top: 10px">
            <span class="cost-title">养生方：</span>
            <span class="cost-content">{{ relevanceInfo.oil_price }}</span>
            <span> 元</span>
          </div>
          <div
            v-if="relevanceInfo.drug_machining_price"
            style="margin-top: 10px"
          >
            <span class="cost-title">加工费：</span>
            <span class="cost-content">{{
              relevanceInfo.drug_machining_price
            }}</span>
            <span> 元</span>
          </div>
          <div v-if="relevanceInfo.excipients_price" style="margin-top: 10px">
            <span class="cost-title">辅料费：</span>
            <span class="cost-content">{{
              relevanceInfo.excipients_price
            }}</span>
            <span> 元</span>
          </div>
          <div style="margin-top: 10px">
            <span class="cost-title">诊后管理费(与药费合并，不单独显示)：</span>
            <span class="cost-content">{{
              relevanceInfo.consult_drug_price
            }}</span>
            <span> 元</span>
          </div>
          <div style="margin: 10px 0">
            <span class="cost-title">诊金(与药费合并，不单独显示)：</span>
            <span class="cost-content">{{
              relevanceInfo.consulting_gold
            }}</span>
            <span> 元</span>
          </div>
          <div>
            <span class="cost-title">总计：</span>
            <span class="cost-content">{{ relevanceInfo.total_price }}</span>
            <span> 元</span>
          </div>
        </div>
      </div>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="recipeDetailDialog = false"
          >关 闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import yewu from "../../../api/yewu";
import platform from "../../../api/platform";
import DocMsg from "../../../components/common/DocMsg.vue";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";

export default {
  data() {
    return {
      pre_img: false,
      sign_img: false,
      detail: {},
      item_list: [],
      oil_item_list: [],
      pm_list: [],
      recipeDetailDialog: false,
      relevanceRecipe: [],
      relevanceInfo: {},
      is_show: 0,
      doc_msg: false,
      doctorId: "",
      return_visit: false,
      preId: 0,
      visitName: "prescription",
      visitType: 3,
      activeIndexDia: "1",
    };
  },
  components: {
    DocMsg,
    ReturnVisit,
  },
  filters: {
    preGroupText(val) {
      switch (val) {
        case 1:
          return "中药材";
        case 2:
          return "中药材";
        case 3:
          return "中药材";
        case 4:
          return "中药材";
        case 0:
          return "养生膏方";
        case -1:
          return "成药";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    getCostTitle() {
      switch (this.detail.pre_group) {
        case 1:
          return "中药材";
        case 2:
          return "中药材";
        case 3:
          return "中药材";
        case 4:
          return "中药材";
        case 0:
          return "养生膏方";
        case -1:
          return "成药";
      }
    },
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取详情
    getDetail() {
      let pre_id = this.$route.query.pre_id;
      this.axios
        .post("platform/Microclinic/prescriptionItem", { pre_id })
        .then((res) => {
          if (res.code == 0) {
            let info = res.data.info;
            this.detail = info;
            this.item_list = info.item_list;
            this.oil_item_list = info.oil_item_list;
            this.pm_list = info.pm_list;
            this.detail.create_time = platform.timestampToTime(
              this.detail.create_time
            );
            if (info.material.length) {
              let material_name_arr = [];
              material_name_arr = info.material.map((item) => {
                return (
                  item.material_name + item.item_use_level + item.material_unit
                );
              });
              this.detail.material_name = material_name_arr.toString();
            }
            this.is_show = this.detail.is_show ? false : true;
            if (this.detail.drug_sign_desc) {
              this.detail.drug_sign_desc = this.detail.drug_sign_desc.replace(
                /配伍/,
                "<br/>配伍"
              );
              this.detail.drug_sign_desc = this.detail.drug_sign_desc.replace(
                /药材剂量/,
                "<br/>药材剂量"
              );
              this.detail.drug_sign_desc = this.detail.drug_sign_desc.replace(
                /肝肾毒性中药提示/,
                "<br/>肝肾毒性中药提示"
              );
            }
            if (Number(this.detail.drug_machining_weight)) {
              this.detail.min_day = (
                Number(this.detail.min_drug_machining_weight) /
                (Number(this.detail.day_num) *
                  Number(this.detail.times_capacity))
              ).toFixed(0);
              this.detail.max_day = (
                Number(this.detail.drug_machining_weight) /
                (Number(this.detail.day_num) *
                  Number(this.detail.times_capacity))
              ).toFixed(0);
            } else {
              this.detail.min_day = 0;
              this.detail.max_day = 0;
            }
          }
        });
    },
    // 查看关联处方
    viewRelevance() {
      yewu
        .joinedPrescriptionItem({ pre_pid: this.detail.pre_pid })
        .then((res) => {
          let { data } = res;
          this.relevanceInfo = _.omit(data, ["list"]);
          this.relevanceRecipe = data.list.map((item) => {
            if (item.material.length) {
              let material_name_arr = [];
              material_name_arr = item.material.map((i) => {
                return i.material_name + i.item_use_level + i.material_unit;
              });
              item.material_name = material_name_arr.toString();
            }
            return item;
          });
        });
      this.recipeDetailDialog = true;
    },
    //取消绑定
    cancelBind() {
      this.axios
        .post("platform/prescription/cancelUserPrescription", {
          pre_id: this.detail.pre_id,
        })
        .then((res) => {
          this.$message.success("解绑成功");
          this.getDetail();
        });
    },
    //改变隐藏剂量
    changeShow(value) {
      this.axios
        .post("platform/prescription/editHiddenDoseState", {
          pre_id: this.detail.pre_id,
          is_show: value,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            this.getDetail();
          }
        });
    },
    //回访
    toReturn() {
      this.preId = this.$route.query.pre_id;
      this.return_visit = !this.return_visit;
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss">
.chufang-detail {
  .dorder-divider {
    border-bottom: 8px solid #f3f3f3;
    // padding-bottom: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .container {
    padding: 20px;
    box-sizing: border-box;
    background-color: #ffffff;
    min-height: calc(100vh - 140px);
    border-radius: 5px;
    text-align: left;
  }
  .inbobox {
    display: flex;
    justify-content: space-between;
    .inboitem {
      padding: 14px 50px 14px 20px;
      box-sizing: border-box;
      margin-bottom: 12px;
      margin-right: 20px;
      background-color: #f9f8ee;
      border: solid 1px #dad8ca;
      .infotitle {
        width: 90px;
        display: inline-block;
      }
    }
  }
  .title {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 20px;
  }
  .rp {
    font-size: 22px;
    color: #000000;
    font-weight: 600;
  }
  .itembox {
    display: flex;
    color: #000;
    flex-wrap: wrap;
    .item {
      min-width: 160px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 40px;
      position: relative;
      margin-bottom: 22px;
    }
    .item::before {
      content: "";
      position: absolute;
      height: 12px;
      width: 1px;
      background: #d7d7d7;
      left: 180px;
      top: 4px;
    }
  }
  .flex-box {
    height: 20px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    .title {
      padding: 0;
    }
  }
  .pre-group {
    padding-left: 20px;
  }
  .cost-detail {
    .cost-title {
      display: inline-block;
      width: 260px;
      text-align: right;
      margin-right: 20px;
    }
    .cost-content {
      color: red;
    }
  }
}
.recipe-detail-dialog {
  .el-dialog__body {
    padding: 10px 20px !important;
  }
  .recipe-detail {
    .dorder-divider {
      border-bottom: 8px solid #f3f3f3;
      padding-top: 10px;
      margin-bottom: 0;
    }
    .title-page {
      height: 20px;
      display: flex;
      align-items: center;
      padding: 4px 0 10px 0;
      p {
        padding-right: 20px;
      }
      .weight {
        font-weight: bold;
      }
    }
    .itembox {
      display: flex;
      color: #000;
      flex-wrap: wrap;
      align-items: center;
      .item {
        min-width: 140px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 40px;
        position: relative;
        margin-bottom: 14px;
      }
      .item::before {
        content: "";
        position: absolute;
        height: 12px;
        width: 1px;
        background: #d7d7d7;
        left: 160px;
        top: 4px;
      }
    }
    .dia-cost-detail {
      padding-top: 20px;
      div {
        display: flex;
        align-items: center;
      }
      .cost-title {
        display: inline-block;
        width: 280px;
        text-align: right;
        margin-right: 10px;
      }
      .cost-content {
        color: red;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .pm-list {
      .pm-box {
        display: flex;
        align-items: center;
        p {
          padding-right: 40px;
          span {
            padding-left: 10px;
          }
        }
      }
    }
    .oil-list {
      .oil-box {
        display: flex;
        align-items: center;
        p {
          padding-right: 40px;
          span {
            padding-left: 10px;
          }
        }
      }
    }
  }
}
</style>
